export const DEFAULT_DIAMETER = '100%';
//# sourceMappingURL=SkeletonCircle.constants.js.map